var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-card-code', {
    attrs: {
      "title": "Border and padding"
    },
    scopedSlots: _vm._u([{
      key: "code",
      fn: function fn() {
        return [_vm._v(" " + _vm._s(_vm.codeBorderPadding) + " ")];
      },
      proxy: true
    }])
  }, [_c('b-card-text', [_vm._v(" Fancy a time control with a border with padding? Use Bootstrap's border and padding utility classes to add borders and padding: ")]), _c('b-time', {
    staticClass: "border rounded p-2",
    attrs: {
      "locale": "en"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }